function isUndefined(x) {
    return x === undefined;
}

export { isUndefined };
